import { IHandleItemEventType } from "../store/types";

const addItem: ItemObjectHandler = <T extends object>(item: ItemDefault<T>, state?: State<T>): State<T> => {
  return state ? { ...state, [item.id]: item } : { [item.id]: item };
};

const updateItem: ItemObjectHandler = <T extends object>(item: ItemDefault<T>, state?: State<T>): State<T> => {
  return state && state[item.id] ? { ...state, [item.id]: { ...state[item.id], ...item } } : state || {};
};

const deleteItem: ItemObjectHandler = <T extends object>(item: ItemDefault<T>, state?: State<T>): State<T> => {
  if (!state) {
    return {};
  }

  const stateCopy = { ...state };
  delete stateCopy[item.id];

  return stateCopy;
};

// Add item to store if there is no item or update item
const storeItem: ItemObjectHandler = <T extends object>(item: ItemDefault<T>, state?: State<T>): State<T> => {
  return state ? { ...state, [item.id]: { ...(state[item.id] || {}), ...item } } : { [item.id]: item };
};

type ItemDefault<T extends object> = T & {
  id: number;
};

type State<T> = { [key: number]: T };

type ItemObjectHandler = <T extends object>(item: ItemDefault<T>, state?: State<T>) => State<T>;

type ItemArrayHandlers = { [key in IHandleItemEventType]: ItemObjectHandler };

export const itemObjectHandlers: ItemArrayHandlers = {
  add: addItem,
  delete: deleteItem,
  update: updateItem,
  store: storeItem
};
